import {event} from "vue-gtag"

export function trackEvent(eventName: string, label: string, category: string = "crm_admin") {
  try {
    event(eventName, {
      event_category: category,
      event_label: label,
      value: 1,
    })
  } catch (e) {
    console.log("GA track is not available", e)
  }
}
